export default {
  name: 'inventaire-info-modal',
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: 'Information' },
    message: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
